import { useSyncExternalStore } from "react";

// SPA replacement for next/router. Only the surface the app uses: push, query, pathname.
const NAV_EVENT = "app:navigate";

function subscribe(callback: () => void) {
  window.addEventListener("popstate", callback);
  window.addEventListener(NAV_EVENT, callback);
  return () => {
    window.removeEventListener("popstate", callback);
    window.removeEventListener(NAV_EVENT, callback);
  };
}

export function navigate(url: string) {
  window.history.pushState({}, "", url);
  window.dispatchEvent(new Event(NAV_EVENT));
}

export function usePathname(): string {
  return useSyncExternalStore(
    subscribe,
    () => window.location.pathname,
    () => "/",
  );
}

function getSearch() {
  return window.location.search;
}

export interface AppRouter {
  pathname: string;
  query: Record<string, string>;
  push: (url: string) => void;
}

export function useRouter(): AppRouter {
  const pathname = usePathname();
  const search = useSyncExternalStore(subscribe, getSearch, () => "");
  return {
    pathname,
    query: Object.fromEntries(new URLSearchParams(search)),
    push: navigate,
  };
}
